module.exports = __webpack_public_path__ + "static/media/more-profiles-icon.9947de86.svg";